module.exports = require("./sd.d.ts");